<div class="page-wrapper">
  <div class="page-header-wrapper">
    <!-- Page header -->
    <app-page-header></app-page-header>
  </div>
  <div class="page-content-wrapper" [ngClass]="pageWrapperClass" role="main">
    <router-outlet></router-outlet>
  </div>
</div>
